import { definitions } from 'api/generated/photorating'

export enum Status {
  Active = 'active',
  Inactive = 'inactive',
  Archived = 'archived',
}

export interface FeaturedPhotosPopularityState {
  featuredPhotosList: definitions['FeaturedPhoto'][]
  loadedActivePhoto: boolean
  maxRatioFeaturedPhoto: number
  archivedFeaturedPhoto: boolean
}

export const initialState: FeaturedPhotosPopularityState = {
  featuredPhotosList: [],
  loadedActivePhoto: false,
  maxRatioFeaturedPhoto: 0,
  archivedFeaturedPhoto: false,
}
